/**
 * Novigran Multistep Form - Frontend Bundle Entry Point
 *
 * @package Novigran_Multistep_Form
 * @since   1.5.5
 * @author  Adrián Ortiz Arandes
 */

import { initDatepickerFilter } from './datepicker-future-dates.js';

// Initialize all frontend modules when DOM is ready
(function($) {
    'use strict';

    $(document).ready(function() {
        // Initialize Gravity Forms datepicker modifications
        initDatepickerFilter();
    });

})(jQuery);
